import { render, staticRenderFns } from "./iconMinibar.vue?vue&type=template&id=5bb5e80a"
import script from "./iconMinibar.vue?vue&type=script&lang=js"
export * from "./iconMinibar.vue?vue&type=script&lang=js"
import style0 from "./iconMinibar.vue?vue&type=style&index=0&id=5bb5e80a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports